import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { deleteWorkflowProcess as _deleteWorkflowProcess, deleteWorkflowProcessByIds, getWorkflowProcessList } from "@/api/workflowProcess"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
export default {
  name: "WorkflowProcess",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getWorkflowProcessList,
      dialogFormVisible: false,
      deleteVisible: false,
      multipleSelection: []
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? "是" : "否";
      } else {
        return "";
      }
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      if (this.searchInfo.hideIcon == "") {
        this.searchInfo.hideIcon = null;
      }
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onDelete: function onDelete() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ids, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = [];
              _this.multipleSelection && _this.multipleSelection.map(function (item) {
                ids.push(item.id);
              });
              _context.next = 4;
              return deleteWorkflowProcessByIds({
                ids: ids
              });
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "删除成功"
                });
                if (_this.tableData.length == ids.length) {
                  _this.page--;
                }
                _this.deleteVisible = false;
                _this.getTableData();
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateWorkflowProcess: function updateWorkflowProcess(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$router.push({
                name: "workflowCreate",
                query: {
                  id: row.id,
                  type: "edit"
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    useWorkflowProcess: function useWorkflowProcess(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$router.push({
                name: "workflowUse",
                query: {
                  workflowId: row.id
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    viewWorkflowProcess: function viewWorkflowProcess(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.$router.push({
                name: "workflowCreate",
                query: {
                  id: row.id,
                  type: "view"
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    deleteWorkflowProcess: function deleteWorkflowProcess(row) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              row.visible = false;
              _context5.next = 3;
              return _deleteWorkflowProcess({
                id: row.id
              });
            case 3:
              res = _context5.sent;
              if (res.code == 0) {
                _this5.$message({
                  type: "success",
                  message: "删除成功"
                });
                if (_this5.tableData.length == 1) {
                  _this5.page--;
                }
                _this5.getTableData();
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    openDialog: function openDialog() {
      this.dialogFormVisible = true;
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _this6.getTableData();
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};